module.exports = __webpack_public_path__ + "img/deskshelf09.9b68e63b.jpg";